export class SubSellers {
  constructor(
    id = "",
    real_company_name = "",
    username = "",
    entity_name = "",
    email = "",
    mobile = "",
    kyc_status = "",
    category_type = "",
    cName = "",
    sName = "",
    dName = "",
    productCount = "",
    companyLogo = "",
    companyBanner = "",
    min_order_amount = "",
    account_status = ""
  ) {
    this.id = id;
    this.real_company_name = real_company_name;
    this.username = username;
    this.entity_name = entity_name;
    this.email = email;
    this.mobile = mobile;
    this.kyc_status = kyc_status;
    this.category_type = category_type;
    this.cName = cName;
    this.sName = sName;
    this.dName = dName;
    this.productCount = productCount;
    this.companyLogo = companyLogo;
    this.companyBanner = companyBanner;
    this.min_order_amount = min_order_amount;
    this.account_status = account_status;
  }
}
